export default function addQueryParams(url, key, value) {
    try {
        const urlData = new URL(url);
        urlData.searchParams.set(key, value);
        return urlData.toString();
    }
    catch (error) {
        return url;
    }
}
